import type { LookupParams } from '@/lib/bootstrap';
import type { BusinessClientSummary } from '@/types';
import { CommandBar } from '@/features/bet-inspection/components/CommandBar';
import { LaneLetter } from './CompareSummary';

/**
 * Two lookup lanes stacked in one sticky bar. Each lane reuses the exact
 * CommandBar from Bet Inspection (same four identity types, same client picker),
 * so the two tools can never drift on how a bet is looked up.
 */
export function CompareBar({
  clients,
  clientsLoading,
  clientsError,
  loadingA,
  loadingB,
  onLookupA,
  onLookupB,
  api,
  token,
}: {
  clients: BusinessClientSummary[];
  clientsLoading: boolean;
  clientsError: boolean;
  loadingA: boolean;
  loadingB: boolean;
  onLookupA: (p: LookupParams) => void;
  onLookupB: (p: LookupParams) => void;
  api: string;
  token: string | null;
}) {
  return (
    <div className="sticky top-[41px] z-30 divide-y divide-hairline border-b border-hairline bg-bg/95 backdrop-blur">
      <CommandBar
        sticky={false}
        initial={null}
        loading={loadingA}
        clients={clients}
        clientsLoading={clientsLoading}
        clientsError={clientsError}
        onLookup={onLookupA}
        submitLabel="Inspect A"
        lead={<LaneLetter letter="A" />}
        api={api}
        token={token}
      />
      <CommandBar
        sticky={false}
        initial={null}
        loading={loadingB}
        clients={clients}
        clientsLoading={clientsLoading}
        clientsError={clientsError}
        onLookup={onLookupB}
        submitLabel="Inspect B"
        lead={<LaneLetter letter="B" />}
        api={api}
        token={token}
      />
    </div>
  );
}
